/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForesightScenarioElement', 'model/ForesightScenarioElementReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForesightScenarioElement'), require('../model/ForesightScenarioElementReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioElementApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForesightScenarioElement, root.ForStractionServiceApi.ForesightScenarioElementReport);
  }
}(this, function(ApiClient, ForesightScenarioElement, ForesightScenarioElementReport) {
  'use strict';

  /**
   * ForesightScenarioElement service.
   * @module api/ForesightScenarioElementApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForesightScenarioElementApi. 
   * @alias module:api/ForesightScenarioElementApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the foresightScenarioElementAddPut operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioElement} body 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.foresightScenarioElementAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioElementAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForesightScenarioElement/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementCopyBudgetFromSourceIndicatorGet operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementCopyBudgetFromSourceIndicatorGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * copyBudgetFromSourceIndicator
     * @param {String} _4SAPIAppID 
     * @param {Integer} elementID 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementCopyBudgetFromSourceIndicatorGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioElementCopyBudgetFromSourceIndicatorGet = function(_4SAPIAppID, elementID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementCopyBudgetFromSourceIndicatorGet";
      }

      // verify the required parameter 'elementID' is set
      if (elementID == undefined || elementID == null) {
        throw "Missing the required parameter 'elementID' when calling foresightScenarioElementCopyBudgetFromSourceIndicatorGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'elementID': elementID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioElement/copyBudgetFromSourceIndicator', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementDeleteAllPut operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioElementDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioElementDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioElement/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementDeleteGet operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} elementID 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioElementDeleteGet = function(_4SAPIAppID, elementID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementDeleteGet";
      }

      // verify the required parameter 'elementID' is set
      if (elementID == undefined || elementID == null) {
        throw "Missing the required parameter 'elementID' when calling foresightScenarioElementDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'elementID': elementID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioElement/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementEditPut operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioElement} body 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioElementEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioElementEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenarioElement/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementLoadGet operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForesightScenarioElementReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} elementID 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForesightScenarioElementReport}
     */
    this.foresightScenarioElementLoadGet = function(_4SAPIAppID, elementID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementLoadGet";
      }

      // verify the required parameter 'elementID' is set
      if (elementID == undefined || elementID == null) {
        throw "Missing the required parameter 'elementID' when calling foresightScenarioElementLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'elementID': elementID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForesightScenarioElementReport;

      return this.apiClient.callApi(
        '/ForesightScenarioElement/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioElementSearchPut operation.
     * @callback module:api/ForesightScenarioElementApi~foresightScenarioElementSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForesightScenarioElementReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioElement} body 
     * @param {module:api/ForesightScenarioElementApi~foresightScenarioElementSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForesightScenarioElementReport>}
     */
    this.foresightScenarioElementSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioElementSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioElementSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForesightScenarioElementReport];

      return this.apiClient.callApi(
        '/ForesightScenarioElement/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
